<script lang="ts">
  import { faExpand } from '@fortawesome/free-solid-svg-icons';
  import type { EditorState } from '../editor-state.svelte';
  import Icon from './Icon.svelte';

  const { editor }: { editor: EditorState } = $props();
</script>

{#if editor.scene.views.length === 0}
  <p class="empty">No views yet; draw one with View.draw().</p>
{:else}
  <ul>
    {#each editor.scene.views as view (view.id)}
      <li>
        <button
          type="button"
          title="Zoom to fit {view.name}"
          onclick={() => editor.zoomToView(view.id)}
        >
          <Icon icon={faExpand} />
          <span class="name">{view.name}</span>
        </button>
      </li>
    {/each}
  </ul>
{/if}

<style>
  ul {
    flex: 1;
    min-height: 0;
    overflow: auto;
    margin: 0;
    padding: 0 0 var(--space-2);
    list-style: none;
  }

  button {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    width: 100%;
    padding: 3px var(--space-3);
    border: 0;
    background: none;
    color: var(--color-text);
    font: inherit;
    font-size: 0.8125rem;
    text-align: left;
    cursor: pointer;
  }

  button:hover {
    background: color-mix(in srgb, var(--color-accent) 12%, transparent);
  }

  button :global(svg) {
    color: var(--color-text-muted);
  }

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .empty {
    margin: 0;
    padding: 0 var(--space-3) var(--space-3);
    font-size: 0.8125rem;
    color: var(--color-text-muted);
  }
</style>
